import React, { useState } from "react";
import "../../styles/desktop/gestao.css";

import IconSobre from "../../assets/svg/sobre";
import LogoutIcon from "../../assets/svg/logoutIcon";
import SettingsIcon from "../../assets/svg/config.jsx";

import Sobre from "./TelaSobre/sobre.js";

export default function Gestao() {
    const [popupAtivoSobre, setPopupAtivoSobre] = useState(false);
    const [popupConfirmacaoLogout, setPopupConfirmacaoLogout] = useState(false);
    const [popupAtivoSettings, setPopupAtivoSettings] = useState(false);

    const handleAbrirSobre = () => {
        setPopupAtivoSobre(true);
    };

    const handleAbrirConfirmacaoLogout = () => {
        setPopupConfirmacaoLogout(true);
    };

    const handleFecharConfirmacaoLogout = () => {
        setPopupConfirmacaoLogout(false);
    };

    const handleLogout = () => {
        sessionStorage.removeItem("user");
        window.location.href = "https://acesso-app.cmd-automacao.com/";
    };

    const handleClose = () => {
        setPopupAtivoSobre(false);
    };

    const handleAbrirSettings = () => {
        setPopupAtivoSettings(true);
    };

    const handleFecharSettings = () => {
        setPopupAtivoSettings(false);
    };


    return (
        <div className="GestaoContent">
            {popupAtivoSobre && (
                <div className="popupOverlay">
                    <div className="popupContent">
                        {popupAtivoSobre && <Sobre onClose={handleClose} />}
                    </div>
                </div>
            )}

            {popupConfirmacaoLogout && (
                <div className="popupOverlay-sair">
                    <div className="popupContent-sair">
                        <h2>Confirmar Logout</h2>
                        <p>Tem certeza de que deseja sair?</p>
                        <div className="popupButtons">
                            <button className="btnConfirmar" onClick={handleLogout}>
                                Sim
                            </button>
                            <button className="btnCancelar" onClick={handleFecharConfirmacaoLogout}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="objetoGestao" onClick={handleAbrirSobre}>
                <div className="tituloGestao">
                    <IconSobre className="iconeGestao"/>
                    <h1 id="txtGestao">Sobre</h1>
                </div>
            </div>

            <div className="objetoGestao" onClick={handleAbrirConfirmacaoLogout}>
                <div className="tituloGestao">
                    <LogoutIcon className="iconeGestaoSair"/>
                    <h1>Sair</h1>
                </div>
            </div>
        </div>
    );
}